import * as a from "react";
import { P as i } from "./index-BwqhVa-H.js";
import { jsx as o } from "react/jsx-runtime";
var t = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), d = "VisuallyHidden", s = a.forwardRef(
  (r, e) => /* @__PURE__ */ o(
    i.span,
    {
      ...r,
      ref: e,
      style: { ...t, ...r.style }
    }
  )
);
s.displayName = d;
export {
  s as V,
  t as a
};
